import React from 'react';
import { withAuthenticator } from '@aws-amplify/ui-react';

const SignIn = () => {
  return <h1>Hello from AWS Amplify</h1>;
};

export default withAuthenticator(SignIn);
